export default __webpack_public_path__ + "public/static/logo-inline.8eb6f855d11c02ec0939e9adde5c2238.svg";